import React from 'react';
import { Loan } from '../types/loan';
import { FileSpreadsheetIcon, TrendingUpIcon, DollarSignIcon, TargetIcon } from 'lucide-react';
interface SummaryCardsProps {
  loans: Loan[];
  currentMarketRate: number;
}
export function SummaryCards({
  loans,
  currentMarketRate
}: SummaryCardsProps) {
  const totalLoans = loans.length;
  const totalVolume = loans.reduce((sum, loan) => sum + loan.loanAmount, 0);
  const rateDifferences = loans.map(loan => loan.interestRate - currentMarketRate);
  const averageRateDiff = totalLoans > 0 ? rateDifferences.reduce((sum, diff) => sum + diff, 0) / totalLoans : 0;
  const highestRateDiff = totalLoans > 0 ? Math.max(...rateDifferences) : 0;
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(value);
  };
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-115">
      <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4 hover:shadow-md hover:border-gray-200 transition-all duration-200" data-id="element-116">
        <div className="p-3.5 bg-violet-50 text-violet-600 rounded-xl" data-id="element-117">
          <TargetIcon className="w-6 h-6" data-id="element-118" />
        </div>
        <div data-id="element-119">
          <p className="text-sm font-medium text-gray-500" data-id="element-120">Matching Loans</p>
          <p className="text-2xl font-bold text-gray-900 tabular-nums" data-id="element-121">
            {totalLoans}
          </p>
        </div>
      </div>

      <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4 hover:shadow-md hover:border-gray-200 transition-all duration-200" data-id="element-122">
        <div className="p-3.5 bg-green-50 text-green-600 rounded-xl" data-id="element-123">
          <DollarSignIcon className="w-6 h-6" data-id="element-124" />
        </div>
        <div data-id="element-125">
          <p className="text-sm font-medium text-gray-500" data-id="element-126">Total Volume</p>
          <p className="text-2xl font-bold text-gray-900 tabular-nums" data-id="element-127">
            {formatCurrency(totalVolume)}
          </p>
        </div>
      </div>

      <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4 hover:shadow-md hover:border-gray-200 transition-all duration-200" data-id="element-128">
        <div className="p-3.5 bg-cyan-50 text-cyan-600 rounded-xl" data-id="element-129">
          <TrendingUpIcon className="w-6 h-6" data-id="element-130" />
        </div>
        <div data-id="element-131">
          <p className="text-sm font-medium text-gray-500" data-id="element-132">Avg Rate Diff</p>
          <p className="text-2xl font-bold text-gray-900 tabular-nums" data-id="element-133">
            +{averageRateDiff.toFixed(2)}%
          </p>
        </div>
      </div>

      <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4 hover:shadow-md hover:border-gray-200 transition-all duration-200" data-id="element-134">
        <div className="p-3.5 bg-red-50 text-red-600 rounded-xl" data-id="element-135">
          <FileSpreadsheetIcon className="w-6 h-6" data-id="element-136" />
        </div>
        <div data-id="element-137">
          <p className="text-sm font-medium text-gray-500" data-id="element-138">Highest Rate Diff</p>
          <p className="text-2xl font-bold text-gray-900 tabular-nums" data-id="element-139">
            +{highestRateDiff.toFixed(2)}%
          </p>
        </div>
      </div>
    </div>;
}